/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

const namespaced = true;

export default {
  namespaced,
  state() {
    return {
      options: [],
      loading: false,
      serverError: '',
    };
  },
  actions: {
    async fetchOptions({ commit, state }, url) {
      // only fetch if not already loaded
      if (state.options.length === 0) {
        commit('SET_LOADING', true);
        await api.get(url)
          .then((response) => {
            commit('SET_OPTIONS', response.data);
            commit('SET_LOADING', false);
          })
          .catch(() => {
            commit('SET_LOADING', false);
          });
      }
    },
    async refreshOptions({ commit }, url) {
      commit('SET_LOADING', true);
      await api.get(url)
        .then((response) => {
          commit('SET_OPTIONS', response.data);
          commit('SET_LOADING', false);
        })
        .catch(() => {
          commit('SET_LOADING', false);
        });
    },
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_OPTIONS(state, options) {
      state.options = options;
    },
  },
  getters: {
    getProperty: state => (id, propertyName) => {
      if (state.options && state.options.length > 0 && state.options.some(p => p.id === id)) {
        return state.options.filter(p => p.id === id)[0][propertyName];
      }
      return '';
    },
    getName: (state, getters) => id => getters.getProperty(id, 'name'),
    getActiveOptions: (state) => {
      if (!state.options || state.options.length === 0) {
        return [];
      }
      const options = state.options.filter(opt => !opt.archiveDate
        || (new Date(opt.archiveDate) > new Date()));
      return options;
    },
    getAllOptions: state => state.options,
  },
};
